import FolderExport from './FolderExport';
import FolderImport from './FolderImport';
import ToolkitExport from './ToolkitExport';
import ToolkitImport from './ToolkitImport';
import ProjectExport from './ProjectExport';
import ProjectImport from './ProjectImport';
import AgentExport from './AgentExport';
import AgentImport from './AgentImport';

type ProgressPanelSubComponents = {
  FolderExport: typeof FolderExport;
  FolderImport: typeof FolderImport;
  ToolkitExport: typeof ToolkitExport;
  ToolkitImport: typeof ToolkitImport;
  ProjectExport: typeof ProjectExport;
  ProjectImport: typeof ProjectImport;
  AgentExport: typeof AgentExport;
  AgentImport: typeof AgentImport;
};

const ProgressPanel: ProgressPanelSubComponents = () => null;

ProgressPanel.FolderExport = FolderExport;
ProgressPanel.FolderImport = FolderImport;
ProgressPanel.ToolkitExport = ToolkitExport;
ProgressPanel.ToolkitImport = ToolkitImport;
ProgressPanel.ProjectExport = ProjectExport;
ProgressPanel.ProjectImport = ProjectImport;
ProgressPanel.AgentExport = AgentExport;
ProgressPanel.AgentImport = AgentImport;

export default ProgressPanel;
